import React, {useState, useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {useQueryClient} from 'react-query'
import {BuilderPage} from './BuilderPage'

export default function BuilderPageWrapper() {
  const [searchType, setSearchType] = useState('Nama Member')
  const [searchQuery, setSearchQuery] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const queryClient = useQueryClient()
  const location = useLocation()

  // Invalidate queries when navigating to /claims route
  useEffect(() => {
    if (location.pathname === '/claims') {
      queryClient.invalidateQueries(['claims'])
      queryClient.invalidateQueries(['myTurnTotal'])
    }
  }, [location.pathname, queryClient])

  const handleSearchTypeChange = (newSearchType: string) => {
    setSearchType(newSearchType)
    setSearchQuery('')
    setCurrentPage(1)
  }

  return (
    <div className='d-flex flex-column flex-grow-1 px-4 py-3'>
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          marginTop: '-65px',
        }}
      >
        <BuilderPage
          searchType={searchType}
          searchQuery={searchQuery}
          onSearchTypeChange={handleSearchTypeChange}
          onSearchQueryChange={setSearchQuery}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      </div>
    </div>
  )
}
